import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { State } from '../../../reducer';
import { namespace } from '../';
import { useActions } from '../../../Actions';
import { UiState } from '../types';

import ReportError from './ReportError';

const ReportModal =  () => {
    const { dismissReportModal } = useActions(namespace);
    const { transaction, state, error } = useSelector<State, State[typeof namespace]>(
        (s) => s[namespace]
    );
    if (state === UiState.Error) {
        return <ReportError transaction={transaction} error={error} dismissModal={dismissReportModal} />;
    }
    return null;
};

export default ReportModal;
